/**
 * Autoplay video — lazy load + pause fuera de viewport + prefers-reduced-motion.
 *
 * Aplica a:
 * - .pdp-autoplay-video: videos en PDP (product-thumbnail.liquid)
 * - .card-autoplay-video: videos en product cards de colecciones (rocket-card-product.liquid)
 *
 * - Inicia con preload="none" (cero bytes hasta acercarse).
 * - Al entrar en viewport: cambia a preload="auto" y llama a play().
 * - Al salir del viewport: pause().
 * - Si el usuario tiene prefers-reduced-motion: reduce, no autoplay (queda el poster).
 */
(function () {
  if (typeof window === 'undefined') return;
  if (!('IntersectionObserver' in window)) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var playVideo = function (video) {
    if (reduceMotion) return;
    if (video.preload !== 'auto') video.preload = 'auto';
    var p = video.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () {
        /* Autoplay bloqueado: dejar el poster visible, no hacer nada. */
      });
    }
  };

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          playVideo(video);
        } else {
          if (!video.paused) video.pause();
        }
      });
    },
    { rootMargin: '200px 0px', threshold: 0.01 }
  );

  var observeAll = function () {
    // Selector extendido: PDP + Collection cards
    document.querySelectorAll('.pdp-autoplay-video:not([data-pdp-observed]), .card-autoplay-video:not([data-pdp-observed])').forEach(function (video) {
      video.setAttribute('data-pdp-observed', '1');
      observer.observe(video);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }

  // Auto-observar nuevos elementos agregados dinámicamente (infinite scroll, filtros AJAX, etc.)
  if ('MutationObserver' in window) {
    var mutationObserver = new MutationObserver(function (mutations) {
      var addedElements = false;
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes) {
          for (var i = 0; i < mutation.addedNodes.length; i++) {
            var node = mutation.addedNodes[i];
            if (node.nodeType === 1) { // Node.ELEMENT_NODE
              if (
                node.classList.contains('card-autoplay-video') ||
                node.classList.contains('pdp-autoplay-video') ||
                node.querySelector('.card-autoplay-video, .pdp-autoplay-video')
              ) {
                addedElements = true;
                break;
              }
            }
          }
        }
      });
      if (addedElements) {
        observeAll();
      }
    });
    mutationObserver.observe(document.body, { childList: true, subtree: true });
  }

  // Re-observar cuando Shopify recarga secciones (customizer) o al cambiar variante.
  document.addEventListener('shopify:section:load', observeAll);
  document.addEventListener('shopify:section:select', observeAll);
  document.addEventListener('variant:change', observeAll);
})();
